import type {
  TDashboardPatientMedEvent,
  TDashboardPatientOverview,
} from 'src/pages/dashboard/_components/dashboard.type'
import { http } from 'src/utils/http.util'

export const DashboardService = {
  get: (
    projectId: number,
  ): Promise<{
    dashboardPatientMedEvents: TDashboardPatientMedEvent[]
    dashboardMedEventIds: number[]
  }> => {
    return http.get(`/projects/${projectId}/dashboards/default`).then((res) => res.data)
  },
  getDashboardPatient: (
    projectId: number,
    patientId: number,
    patientMedEventId: number,
  ): Promise<TDashboardPatientOverview> => {
    return http
      .get(`/projects/${projectId}/patients/${patientId}/overview?patientMedEventId=${patientMedEventId}`)
      .then((res) => res.data)
  },
  updateDashboardPatientMedEventSatus: (
    projectId: number,
    patientId: number,
    patientMedEventId: number,
    body: any,
  ) => {
    return http.put(
      `/projects/${projectId}/patients/${patientId}/overview/status?patientMedEventId=${patientMedEventId}`,
      body,
    )
  },
}
